import {Block, Col} from 'jsxstyle'
import React from 'react'
import {ReactComponent as DeleteIcon} from '../../common/assets/delete-icon.svg'

const Error: React.FC = () => {
  return (
    <Col height="100vh" justifyContent="center" alignItems="center" gap="16px" backgroundColor="#f8d7da" padding="20px">
      <Block>
        <DeleteIcon width="80px" height="80px" fill="#721c24" />
      </Block>
      <Block fontSize="32px" fontWeight="bold" color="#721c24">
        Error
      </Block>
      <Block fontSize="18px" color="#721c24">
        Invalid or expired token.
      </Block>
      <Block height="1px" width="50%" backgroundColor="#721c24" margin="12px 0" />
      <Block fontSize="16px" color="#721c24">
        Please refresh the portal from the flow.
      </Block>
    </Col>
  )
}

export default Error
